import { styled } from "@mui/material/styles";

const TablesMainStyle = styled("div")(({ theme }) => ({
  "& .TableWrapper ": {
    marginTop: "0px",
  },
}));

export { TablesMainStyle };
